const configMutation = {
	setTempObjDirection: (state, payload) => (state.tempObjDirection = payload),
	setTempFillDirection: (state, payload) => (state.tempFillDirection = payload),
	setTempImgZoomRate: (state, payload) => (state.tempImgZoomRate = payload),
	setTempActiveArea: (state, payload) => (state.tempActiveArea = payload),
	setTempRotateArea: (state, payload) => (state.tempRotateArea = payload),
	setTemObjFormat: (state, payload) => (state.temObjFormat = payload),
	setTempCurrentImgIndex: (state, payload) => (state.tempCurrentImgIndex = payload),
	setTempRectTitle: (state, payload) => (state.tempRectTitle = payload),
	setTempRectExamNoInfo: (state, payload) => (state.tempRectExamNoInfo = payload),
	setTempScalePage: (state, payload) => (state.tempScalePage = payload),
	setTempEditImgInfo: (state, payload) => (state.tempEditImgInfo = payload),
	setTabActive: (state, payload) => (state.tabActive = payload),
	setTypeLack: (state, payload) => (state.typeLack = payload),
	setTempChooseList: (state, payload) => (state.tempChooseList = payload),
	setOperateCurPage: (state, payload) => (state.operateCurPage = payload),
	setTempSubList: (state, payload) => (state.tempSubList = payload),
	setTempSelLikeSubOrObjVal: (state, payload) => (state.tempSelLikeSubOrObjVal = payload),
	setTempExamNoType: (state, payload) => (state.tempExamNoType = payload),
	setTempLack: (state, payload) => (state.tempLack = payload),
	setTempRectObjective: (state, payload) => (state.tempRectObjective = payload),
	setTempRectSubjective: (state, payload) => (state.tempRectSubjective = payload),
	setTempTopicCurrentIndex: (state, payload) => (state.tempTopicCurrentIndex = payload),
	setTempScrollTop: (state, payload) => (state.tempScrollTop = payload),
	setTempScrollLeft: (state, payload) => (state.tempScrollLeft = payload),
	setTempOriginFlag: (state, payload) => (state.tempOriginFlag = payload),
	setTempFlushData: (state, payload) => (state.tempFlushData = payload),
	setTempRightKeyFixRectInfo: (state, payload) => (state.tempRightKeyFixRectInfo = payload),
	setTempReferTabState: (state, payload) => (state.tempReferTabState = payload),
	setGroupListDetail: (state, payload) => (state.groupListDetail = payload),
	setTempObjTabState: (state, payload) => (state.tempObjTabState = payload),
	setTempRectSliceList: (state, payload) => (state.tempRectSliceList = payload),
	setChooseTabState: (state, payload) => (state.chooseTabState = payload),
	setDotType: (state, payload) => (state.dotType = payload),
	setTempReferRectList: (state, payload) => (state.tempReferRectList = payload),
	setTempSelLikeSubOrObj: (state, payload) => (state.tempSelLikeSubOrObj = payload),
	setTempSelLikeSubOrObjName: (state, payload) => (state.tempSelLikeSubOrObjName = payload),
	setTempSliceTopic: (state, payload) => (state.tempSliceTopic = payload),
	setTempCurrentRefer: (state, payload) => (state.tempCurrentRefer = payload),
	setTempSubTabState: (state, payload) => (state.tempSubTabState = payload),
	setTempHandleReset: (state, payload) => (state.tempHandleReset = payload),
	setTempFixRectTitle: (state, payload) => (state.tempFixRectTitle = payload),
	setTempExamObjAddRect: (state, payload) => (state.tempExamObjAddRect = payload),
	setHandleSliceOriginClick: (state, payload) => (state.handleSliceOriginClick = payload),
	setHandHandleState: (state, payload) => (state.handHandleState = payload),
	setWsState: (state, payload) => (state.wsState = payload),
	setTempObjTopic: (state, payload) => (state.tempObjTopic = payload),
	setCanDrawRect: (state, payload) => (state.canDrawRect = payload),
	setHandleSetObjVal: (state, payload) => (state.handleSetObjVal = payload),
	setCopyObjState: (state, payload) => (state.copyObjState = payload),
	setObjCanKeyDel: (state, payload) => (state.objCanKeyDel = payload),
	setTempSelLikeSub: (state, payload) => (state.tempSelLikeSub = payload),
	setTempRowNum: (state, payload) => (state.tempRowNum = payload),
	setTempInitObjTopic: (state, payload) => (state.tempInitObjTopic = payload)
}

export default configMutation
